module.exports = __webpack_public_path__ + "img/Add.30e1cd20.svg";